
import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    id: 1,
    image:
      "https://public.readdy.ai/ai/img_res/c09bcefda169caf994920c8971818ae6.jpg",
  },
  {
    id: 2,
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20colorful%20storybooks%20and%20creative%20writing%20notebooks%20arranged%20beautifully%20on%20a%20warm%20wooden%20desk%20with%20soft%20natural%20lighting%20pencils%20pens%20and%20educational%20materials%20scattered%20artistically%20bright%20cheerful%20educational%20still%20life%20photography%20warm%20golden%20tones%20cream%20background%20high%20quality%20professional%20photo&width=1920&height=1080&seq=hero-slide-bright-002&orientation=landscape",
  },
  {
    id: 3,
    image:
      "https://readdy.ai/api/search-image?query=Bright%20cheerful%20classroom%20setting%20with%20warm%20golden%20sunlight%20streaming%20through%20large%20windows%20empty%20desks%20arranged%20neatly%20with%20open%20books%20and%20stationery%20welcoming%20educational%20environment%20with%20green%20plants%20and%20warm%20cream%20walls%20inviting%20atmosphere%20for%20new%20students%20professional%20interior%20photography%20soft%20warm%20tones&width=1920&height=1080&seq=hero-slide-bright-003&orientation=landscape",
  },
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isClassesDropdownOpen, setIsClassesDropdownOpen] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  const goToSlide = useCallback(
    (index: number) => {
      if (isTransitioning || index === currentSlide) return;
      setIsTransitioning(true);
      setCurrentSlide(index);
      setTimeout(() => setIsTransitioning(false), 700);
    },
    [currentSlide, isTransitioning]
  );

  const nextSlide = useCallback(() => {
    goToSlide((currentSlide + 1) % slides.length);
  }, [currentSlide, goToSlide]);

  const prevSlide = useCallback(() => {
    goToSlide((currentSlide - 1 + slides.length) % slides.length);
  }, [currentSlide, goToSlide]);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Navigation Header - Always has its own background */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? "bg-white shadow-lg" : "bg-[#153223]"
        }`}
      >
        <nav className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div
              className="flex items-center gap-3 cursor-pointer"
              onClick={handleScrollToTop}
            >
              <img
                src="https://static.readdy.ai/image/80fafa544acf55a90d716b5bdc1b1a54/d0ca68546255ea784fe6ebf2c5df36a2.png"
                alt="OHT Academy Logo"
                className="w-11 h-11 object-contain"
              />
              <span
                className={`font-['Yeseva_One',serif] text-lg transition-colors ${
                  isScrolled ? "text-[#153223]" : "text-[#FFE66D]"
                }`}
              >
                OHT Academy
              </span>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-7">
              <button
                onClick={() => scrollToSection("about")}
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-[#153223] hover:text-[#C8A951]"
                    : "text-white/90 hover:text-[#FFE66D]"
                }`}
              >
                About Us
              </button>

              {/* Our Classes Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setIsClassesDropdownOpen(true)}
                onMouseLeave={() => setIsClassesDropdownOpen(false)}
              >
                <button
                  onClick={() => scrollToSection("programs")}
                  className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer flex items-center gap-1 ${
                    isScrolled
                      ? "text-[#153223] hover:text-[#C8A951]"
                      : "text-white/90 hover:text-[#FFE66D]"
                  }`}
                >
                  Our Classes
                  <i
                    className={`ri-arrow-down-s-line text-base transition-transform ${
                      isClassesDropdownOpen ? "rotate-180" : ""
                    }`}
                  ></i>
                </button>

                {isClassesDropdownOpen && (
                  <div
                    className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-xl py-2 min-w-[220px] z-50"
                    onMouseEnter={() => setIsClassesDropdownOpen(true)}
                    onMouseLeave={() => setIsClassesDropdownOpen(false)}
                  >
                    <Link
                      to="/book-reading-class"
                      onClick={handleScrollToTop}
                      className="whitespace-nowrap block px-4 py-3 text-[#153223] hover:bg-[#FFE66D]/20 font-semibold transition-colors cursor-pointer flex items-center gap-2 text-sm"
                    >
                      <i className="ri-book-open-line text-base"></i>
                      Book Reading Class
                    </Link>
                    <Link
                      to="/focus-writing-class"
                      onClick={handleScrollToTop}
                      className="whitespace-nowrap block px-4 py-3 text-[#153223] hover:bg-[#FFE66D]/20 font-semibold transition-colors cursor-pointer flex items-center gap-2 text-sm"
                    >
                      <i className="ri-quill-pen-line text-base"></i>
                      Focus Writing Class
                    </Link>
                  </div>
                )}
              </div>

              <button
                onClick={() => scrollToSection("why-choose-us")}
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-[#153223] hover:text-[#C8A951]"
                    : "text-white/90 hover:text-[#FFE66D]"
                }`}
              >
                Our Values
              </button>

              <button
                onClick={() => scrollToSection("faq")}
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-[#153223] hover:text-[#C8A951]"
                    : "text-white/90 hover:text-[#FFE66D]"
                }`}
              >
                FAQ
              </button>
              <button
                onClick={() => scrollToSection("contact")}
                className={`whitespace-nowrap text-sm font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? "text-[#153223] hover:text-[#C8A951]"
                    : "text-white/90 hover:text-[#FFE66D]"
                }`}
              >
                Contact
              </button>
              <Link
                to="/level-test-registration"
                onClick={handleScrollToTop}
                className="whitespace-nowrap bg-[#FFE66D] hover:bg-[#FFD93D] text-[#153223] font-bold px-5 py-2 rounded-lg transition-all duration-300 cursor-pointer text-sm"
              >
                Register For Level Test
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden text-2xl cursor-pointer ${
                isScrolled ? "text-[#153223]" : "text-white"
              }`}
            >
              <i
                className={isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}
              ></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden mt-4 bg-white rounded-lg shadow-lg p-4">
              <div className="flex flex-col gap-4">
                <button
                  onClick={() => scrollToSection("about")}
                  className="whitespace-nowrap text-[#153223] hover:text-[#C8A951] font-semibold text-left cursor-pointer"
                >
                  About Us
                </button>

                <div>
                  <button
                    onClick={() =>
                      setIsClassesDropdownOpen(!isClassesDropdownOpen)
                    }
                    className="whitespace-nowrap text-[#153223] hover:text-[#C8A951] font-semibold text-left cursor-pointer flex items-center gap-1 w-full"
                  >
                    Our Classes
                    <i
                      className={`ri-arrow-down-s-line text-lg transition-transform ${
                        isClassesDropdownOpen ? "rotate-180" : ""
                      }`}
                    ></i>
                  </button>
                  {isClassesDropdownOpen && (
                    <div className="ml-4 mt-2 space-y-2">
                      <Link
                        to="/book-reading-class"
                        onClick={() => {
                          handleScrollToTop();
                          setIsMobileMenuOpen(false);
                        }}
                        className="whitespace-nowrap block text-[#153223] hover:text-[#C8A951] font-medium cursor-pointer flex items-center gap-2"
                      >
                        <i className="ri-book-open-line"></i>
                        Book Reading Class
                      </Link>
                      <Link
                        to="/focus-writing-class"
                        onClick={() => {
                          handleScrollToTop();
                          setIsMobileMenuOpen(false);
                        }}
                        className="whitespace-nowrap block text-[#153223] hover:text-[#C8A951] font-medium cursor-pointer flex items-center gap-2"
                      >
                        <i className="ri-quill-pen-line"></i>
                        Focus Writing Class
                      </Link>
                    </div>
                  )}
                </div>

                <button
                  onClick={() => scrollToSection("why-choose-us")}
                  className="whitespace-nowrap text-[#153223] hover:text-[#C8A951] font-semibold text-left cursor-pointer"
                >
                  Our Values
                </button>

                <button
                  onClick={() => scrollToSection("faq")}
                  className="whitespace-nowrap text-[#153223] hover:text-[#C8A951] font-semibold text-left cursor-pointer"
                >
                  FAQ
                </button>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="whitespace-nowrap text-[#153223] hover:text-[#C8A951] font-semibold text-left cursor-pointer"
                >
                  Contact
                </button>
                <Link
                  to="/level-test-registration"
                  onClick={handleScrollToTop}
                  className="whitespace-nowrap bg-[#FFE66D] hover:bg-[#FFD93D] text-[#153223] font-bold px-6 py-2 rounded-lg transition-all duration-300 text-center cursor-pointer"
                >
                  Register For Level Test
                </Link>
              </div>
            </div>
          )}
        </nav>
      </header>

      {/* Hero Carousel Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Images - Carousel Slide */}
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className="absolute inset-0 transition-all duration-700 ease-in-out"
            style={{
              transform: `translateX(${(index - currentSlide) * 100}%)`,
              zIndex: 1,
            }}
          >
            <div
              className="absolute inset-0 bg-cover bg-top"
              style={{
                backgroundImage: `url('${slide.image}')`,
              }}
            />
            {/* Brighter overlay - warm cream/gold tint */}
            <div className="absolute inset-0 bg-gradient-to-b from-[#153223]/60 via-[#153223]/50 to-[#153223]/65" />
          </div>
        ))}

        {/* Slide Content */}
        <div className="relative z-10 w-full mt-16 md:mt-0">
          {/* Slide 1 - Academy Introduction */}
          <div
            className={`absolute inset-0 flex items-center justify-center transition-all duration-700 ease-in-out ${
              currentSlide === 0
                ? "opacity-100 translate-x-0"
                : currentSlide > 0
                ? "opacity-0 -translate-x-full"
                : "opacity-0 translate-x-full"
            }`}
          >
            <div className="max-w-5xl mx-auto px-6 text-center">
              <div className="inline-block bg-[#FFE66D]/20 backdrop-blur-sm border border-[#FFE66D]/40 rounded-full px-5 py-2 mb-6">
                <span className="text-[#FFE66D] text-sm font-semibold tracking-wide">
                  Welcome to OHT Academy
                </span>
              </div>
              <h1 className="font-['Yeseva_One',serif] text-4xl md:text-6xl lg:text-7xl text-white mb-5 leading-tight">
                OHT Tuition Academy
              </h1>
              <p className="text-lg md:text-2xl text-[#FFE66D] font-semibold mb-4">
                An English Language Home Tuition Academy
              </p>
              <p className="text-base md:text-xl text-white/90 max-w-3xl mx-auto mb-8 leading-relaxed">
                A one-of-a-kind home-based English academy in Bukit Damansara,
                Kuala Lumpur, helping students aged 6–14 build confident
                reading skills, strong vocabulary, and clear writing through
                structured programs.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <button
                  onClick={() => scrollToSection("about")}
                  className="whitespace-nowrap bg-[#FFE66D] hover:bg-[#FFD93D] text-[#153223] font-bold px-7 py-3 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer flex items-center gap-2 text-base"
                >
                  <i className="ri-information-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  Learn More About Us
                </button>
                <a
                  href="https://wa.link/zxuf0o"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-semibold px-7 py-3 rounded-lg transition-all duration-300 border border-white/30 cursor-pointer flex items-center gap-2 text-base"
                >
                  <i className="ri-whatsapp-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  WhatsApp Us
                </a>
              </div>
            </div>
          </div>

          {/* Slide 2 - Specialised Classes */}
          <div
            className={`absolute inset-0 flex items-center justify-center transition-all duration-700 ease-in-out ${
              currentSlide === 1
                ? "opacity-100 translate-x-0"
                : currentSlide > 1
                ? "opacity-0 -translate-x-full"
                : "opacity-0 translate-x-full"
            }`}
          >
            <div className="max-w-5xl mx-auto px-6 text-center">
              <div className="inline-block bg-[#FFE66D]/20 backdrop-blur-sm border border-[#FFE66D]/40 rounded-full px-5 py-2 mb-6">
                <span className="text-[#FFE66D] text-sm font-semibold tracking-wide">
                  Our Specialised Programmes
                </span>
              </div>
              <h2 className="font-['Yeseva_One',serif] text-3xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight">
                Classes Built for Real Progress
              </h2>
              <p className="text-base md:text-lg text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed">
                We specialise in two core programmes designed to develop
                strong English foundations for Malaysian and ESL learners.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
                {/* Book Reading Class Card */}
                <Link
                  to="/book-reading-class"
                  onClick={handleScrollToTop}
                  className="group bg-white/15 backdrop-blur-md border border-white/20 rounded-xl p-6 md:p-8 text-left hover:bg-white/25 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FFE66D]/20 rounded-lg mb-4">
                    <i className="ri-book-open-line text-2xl text-[#FFE66D]"></i>
                  </div>
                  <h3 className="font-['Yeseva_One',serif] text-xl md:text-2xl text-white mb-3">
                    Book Reading Class
                  </h3>
                  <p className="text-white/80 text-sm md:text-base leading-relaxed mb-4">
                    Storybook-based reading programme that builds
                    vocabulary, comprehension, and a love for reading through
                    carefully curated books for each level.
                  </p>
                  <span className="text-[#FFE66D] text-sm font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                    Explore Programme <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>

                {/* Focus Writing Class Card */}
                <Link
                  to="/focus-writing-class"
                  onClick={handleScrollToTop}
                  className="group bg-white/15 backdrop-blur-md border border-white/20 rounded-xl p-6 md:p-8 text-left hover:bg-white/25 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FFE66D]/20 rounded-lg mb-4">
                    <i className="ri-quill-pen-line text-2xl text-[#FFE66D]"></i>
                  </div>
                  <h3 className="font-['Yeseva_One',serif] text-xl md:text-2xl text-white mb-3">
                    Focus Writing Class
                  </h3>
                  <p className="text-white/80 text-sm md:text-base leading-relaxed mb-4">
                    Structured writing programme that develops clear
                    expression, grammar accuracy, and creative writing skills
                    through guided practice and feedback.
                  </p>
                  <span className="text-[#FFE66D] text-sm font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                    Explore Programme <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>

          {/* Slide 3 - Enrolment & Level Test */}
          <div
            className={`absolute inset-0 flex items-center justify-center transition-all duration-700 ease-in-out ${
              currentSlide === 2
                ? "opacity-100 translate-x-0"
                : currentSlide > 2
                ? "opacity-0 -translate-x-full"
                : "opacity-0 translate-x-full"
            }`}
          >
            <div className="max-w-5xl mx-auto px-6 text-center">
              <div className="inline-block bg-[#FFE66D]/20 backdrop-blur-sm border border-[#FFE66D]/40 rounded-full px-5 py-2 mb-6">
                <span className="text-[#FFE66D] text-sm font-semibold tracking-wide">
                  Join Us Anytime
                </span>
              </div>
              <h2 className="font-['Yeseva_One',serif] text-3xl md:text-5xl lg:text-6xl text-white mb-5 leading-tight">
                Class Enrolment Available<br />
                All Year Round
              </h2>
              <p className="text-base md:text-xl text-white/90 max-w-3xl mx-auto mb-5 leading-relaxed">
                No need to wait for a new term. Start your child&apos;s learning
                journey at any time with our flexible rolling enrolment.
              </p>

              <div className="bg-white/15 backdrop-blur-md border border-white/20 rounded-xl p-6 md:p-8 max-w-2xl mx-auto mb-8">
                <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/90 text-sm md:text-base">
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-[#FFE66D] text-lg w-5 h-5 flex items-center justify-center"></i>
                    <span>Premium &amp; Standard Class Options</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-[#FFE66D] text-lg w-5 h-5 flex items-center justify-center"></i>
                    <span>Online Class Also Available</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-[#FFE66D] text-lg w-5 h-5 flex items-center justify-center"></i>
                    <span>Ages 6–14</span>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <Link
                  to="/level-test-registration"
                  onClick={handleScrollToTop}
                  className="whitespace-nowrap bg-[#FFE66D] hover:bg-[#FFD93D] text-[#153223] font-bold px-7 py-3.5 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer flex items-center gap-2 text-base md:text-lg"
                >
                  <i className="ri-file-list-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  Register for Level Test
                </Link>
                <button
                  onClick={() => scrollToSection("enrolment")}
                  className="whitespace-nowrap bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-semibold px-7 py-3.5 rounded-lg transition-all duration-300 border border-white/30 cursor-pointer flex items-center gap-2 text-base"
                >
                  <i className="ri-calendar-check-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  View Enrolment Details
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Carousel Arrow Controls */}
        <button
          onClick={prevSlide}
          className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-20 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm rounded-full border border-white/20 text-white transition-all duration-300 cursor-pointer"
          aria-label="Previous slide"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-20 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm rounded-full border border-white/20 text-white transition-all duration-300 cursor-pointer"
          aria-label="Next slide"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-6 md:bottom-10 left-1/2 -translate-x-1/2 flex gap-3 z-20">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`h-2.5 rounded-full transition-all duration-500 cursor-pointer ${
                currentSlide === index
                  ? "bg-[#FFE66D] w-8"
                  : "bg-white/40 hover:bg-white/70 w-2.5"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </section>
    </>
  );
}
